<template>
  <div class="wrap">
    <h1 class="row">
      {{translate('inspection-report')}}
    </h1>
    <table class="row">
      <tr>
        <td>
          <div class="table__cell">
            <span class="title">{{translate('company')}}</span>: {{rfq3.rfq.customerCompany.name}}
          </div>
        </td>
        <td>
          <div class="table__cell">
            <span class="title">{{translate('contact')}}</span>: {{rfq3.rfq.customerContact.name}}
          </div>
        </td>
      </tr>
      <tr>
      <tr>
        <td>
          <div class="table__cell">
            <span class="title">{{translate('po')}}</span>: {{rfq3.rfq.po}}
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="table__cell">
            <span class="title">{{translate('po-date')}}</span>: {{rfq3.rfq.poDate | toDate}}
          </div>
        </td>
        <td>
          <div class="table__cell">
            <span class="title">{{translate('td-date')}}</span>: {{today | toDate}}
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="table__cell">
            <span class="title">{{translate('part-number')}}</span>: {{repairReport.part.partNumber}}
          </div>
        </td>
        <td>
          <div class="table__cell">
            <span class="title">{{translate('part-desc')}}</span>: {{repairReport.part.partDescription}}
          </div>
        </td>
        <td>
          <div class="table__cell">
            <span class="title">{{translate('part-sn')}}</span>: {{repairReport.partSN}}
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="table__cell">
            <span class="title">{{translate('reason-of-removal')}}</span>: {{rfq2.reasonForRemoval}}
          </div>
        </td>
      </tr>
    </table>
    <table class="row">
      <tr>
        <td style="width: 25%" valign="top">
          <div class="table__cell">
            <span class="title">{{translate('investigation')}}</span>:
          </div>
        </td>
        <td>
          <div class="table__cell">{{repairReport.typeOfOperation.title}}</div>
        </td>
      </tr>
      <tr>
        <td style="width: 25%" valign="top">
          <div class="table__cell">
            <span class="title">{{translate('shop-finding')}}</span>:
          </div>
        </td>
        <td>
          <div class="table__cell">{{repairReport.rsFinding}}</div>
        </td>
      </tr>
    </table>
    <table-list
      :hideEmpty="true"
      :columns="[
          { label: translate('part-number'), renderColumn: (row) => row.partNumber },
          { label: translate('part-description'), renderColumn: (row) => row.partDescription },
          { label: translate('qty'), renderColumn: (row) => row.qty }
        ]"
      :data="replacementParts"
    >
    </table-list>
    <div class="row">
      <div class="box-content">
        <div class="table__cell">
          <span class="title">{{translate('estimation-delivery')}}:</span> {{repairReport.leadTime | toDate}}
        </div>
        <div class="table__cell">
          <span class="title">{{translate('total-cost')}}:</span> {{repairReport.baxTotalCost}} {{repairReport.baxCurrency.title}}
        </div>
      </div>
    </div>
    <div class="row">
      <div v-html="content.html2"></div>
    </div>
    <div class="row">
      <div class="box-content">
        <div class="table__cell">
          <span class="title">{{translate('charge-if-work-discontinue')}}:</span> {{repairReport.inspectionFee}} {{repairReport.baxCurrency.title}}
        </div>
      </div>
    </div>
    <div class="row">
      {{repairReport.remarks}}
    </div>
    <div class="row">
      <div class="box-content">
        <table>
          <tr>
            <td style="width: 30%"><div class="table__cell">{{translate('ok-to-proceed')}}</div></td>
            <td style="width: 20%"><div class="table__cell">{{translate('yes')}}</div></td>
            <td style="width: 20%"><div class="table__cell">{{translate('no')}}</div></td>
            <td style="width: 30%"><div class="table__cell">{{translate('test-chages-will-be-invoiced')}}</div></td>
          </tr>
        </table>
        <table>
          <tr>
            <td style="width: 40%">
              <div class="table__cell">{{translate('quote-approved-by')}} ({{translate('signature-company-stamp')}}):</div>
            </td>
            <td style="width: 30%">
              <div class="bottom-line">text</div>
            </td>
            <td style="width: 10%">
              <div class="table__cell">{{translate('date')}}: </div>
            </td>
            <td style="width: 25%">
              <div class="bottom-line">text</div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row">
      <div v-html="content.html1"></div>
    </div>
  </div>
</template>
<script>
import TableList from './components/table-list'

export default {
  name: 'PdfTd',
  components: {
    'table-list': TableList
  },
  props: {
    translate: {
      type: Function
    },
    rfq2: {
      type: Object,
      default: () => ({
        reasonForRemoval: ''
      })
    },
    rfq3: {
      type: Object
    },
    repairReport: {
      type: Object,
      default: () => ({
        part: {},
        typeOfOperation: {},
        baxCurrency: {}
      })
    },
    replacementParts: {
      type: Array
    },
    content: {
      type: Object
    }
  },
  computed: {
    today () {
      return new Date()
    }
  }
}
</script>
